import { useCallback } from 'react';

import type { ActivityViewProps } from '../../core/types/activity.types';
import { CountingCollectionView } from './CountingCollectionView';

export function CountingCollectionActivityView(props: ActivityViewProps<'counting_collection'>) {
  const answers = props.runtime?.answers ?? {};

  const onAnswerChange = useCallback(
    (groupId: string, answer: string) => {
      props.dispatch({
        type: 'SUBMIT',
        payload: { [groupId]: answer },
      });
    },
    [props.dispatch],
  );

  return (
    <CountingCollectionView
      payload={props.payload}
      answers={answers}
      interactive={!props.readOnly && props.role === 'student'}
      onAnswerChange={onAnswerChange}
    />
  );
}
